/**
 * Developer: Stepan Burguchev
 * Date: 12/12/2016
 * Copyright: 2009-2016 Comindware®
 *       All Rights Reserved
 *
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF Comindware
 *       The copyright notice above does not evidence any
 *       actual or intended publication of such source code.
 */

export default {
    editors: {},
    validators: {}
};



// WEBPACK FOOTER //
// ../src/form/formRepository.js